export const AUTH_TYPE_LOC_KEYS = {
  SKYKICK: 'settings.common.authentication.skykick',
  M365: 'settings.common.authentication.m365',
  CONNECTWISE: 'settings.common.authentication.connectwise',
  SKYKICK_MFA: 'settings.common.authentication.skykick-mfa'
};
